import { APP_VERSION } from '@/version'

// Proje bazlı localStorage anahtarı (projeler arası çakışmayı önler)
const RAW_PROJECT_KEY = process.env.VUE_APP_PROJECT_KEY || null
const PROJECT_KEY = (typeof RAW_PROJECT_KEY === 'string' ? RAW_PROJECT_KEY.trim() : '') || 'default'
const STORAGE_KEY = `${PROJECT_KEY}_app_versiyon`
const DEFAULT_STORAGE_KEY = 'default_app_versiyon'
const LEGACY_STORAGE_KEY = 'app_version'

export const APP_VERSION_STORAGE_KEY = STORAGE_KEY
export const APP_PROJECT_KEY = PROJECT_KEY

const setStoredVersion = version => {
  localStorage.setItem(STORAGE_KEY, version)
}

const getStoredVersion = () => localStorage.getItem(STORAGE_KEY) || null

// Sunucudaki güncel versiyonu public/version.json'dan çek (cache kapalı)
const getLatestVersionFromServer = async () => {
  const url = `/version.json?t=${Date.now()}`
  const res = await fetch(url, {
    cache: 'no-store',
    headers: {
      'cache-control': 'no-cache',
      pragma: 'no-cache',
    },
  })

  if (!res.ok) throw new Error(`version.json fetch failed: ${res.status}`)

  const data = await res.json()
  const version = typeof data?.version === 'string' ? data.version.trim() : null
  const builtAt = typeof data?.builtAt === 'string' ? data.builtAt : null

  return { version, builtAt, source: 'public/version.json' }
}

// Basit semver karşılaştırma: 1.2.10 > 1.2.3
// Dönüş: 1 (a>b), 0 (eşit), -1 (a<b), null (parse edilemedi)
const compareSemver = (a, b) => {
  if (typeof a !== 'string' || typeof b !== 'string') return null

  const pa = a.split('.').map(x => Number.parseInt(x, 10))
  const pb = b.split('.').map(x => Number.parseInt(x, 10))
  if (pa.some(Number.isNaN) || pb.some(Number.isNaN)) return null

  const len = Math.max(pa.length, pb.length)
  for (let i = 0; i < len; i++) {
    const av = pa[i] ?? 0
    const bv = pb[i] ?? 0
    if (av > bv) return 1
    if (av < bv) return -1
  }
  return 0
}

export const checkVersion = async () => {
  try {
    const appVersion = APP_VERSION
    const storedVersion = getStoredVersion()

    let server = null
    try {
      server = await getLatestVersionFromServer()
    } catch {
      server = null
    }

    const latestVersion = server?.version || appVersion

    // Sunucudaki versiyon, localStorage'daki eski versiyondan büyükse güncelleme var
    const baseVersion = storedVersion || appVersion
    const semverCmp = compareSemver(latestVersion, baseVersion)
    const hasUpdate = semverCmp === null ? latestVersion !== baseVersion : semverCmp === 1

    return {
      hasUpdate,
      currentVersion: baseVersion,
      latestVersion,
      builtAt: server?.builtAt || null,
      source: server?.source || 'build',
    }
  } catch (error) {
    console.error('Versiyon kontrolü sırasında hata:', error)
    return {
      hasUpdate: false,
      currentVersion: APP_VERSION,
      error: true,
    }
  }
}

export const updateVersion = latestVersion => {
  const next = typeof latestVersion === 'string' && latestVersion.trim()
    ? latestVersion.trim()
    : APP_VERSION

  setStoredVersion(next)
  return { currentVersion: next, updated: true }
}

// İlk yüklemede: legacy key'den yeni key'e tek seferlik taşı
if (!localStorage.getItem(STORAGE_KEY) && localStorage.getItem(LEGACY_STORAGE_KEY)) {
  localStorage.setItem(STORAGE_KEY, localStorage.getItem(LEGACY_STORAGE_KEY))
}

// Eskiden default key kullanıldıysa ve artık project key geldiyse taşı
if (PROJECT_KEY !== 'default' && !localStorage.getItem(STORAGE_KEY) && localStorage.getItem(DEFAULT_STORAGE_KEY)) {
  localStorage.setItem(STORAGE_KEY, localStorage.getItem(DEFAULT_STORAGE_KEY))
}

if (!localStorage.getItem(STORAGE_KEY)) {
  setStoredVersion(APP_VERSION)
}
